import { cn } from "@/lib/utils";
import {
  INTERACTIVE_ILLUSTRATION_ALT,
  INTERACTIVE_ILLUSTRATION_SRC,
  type InteractiveIllustrationKind,
} from "@/lib/interactiveIllustration";

interface InteractiveElementIllustrationProps {
  kind: InteractiveIllustrationKind;
  className?: string;
}

/** HTML width/height for the `size-36` frame (9rem at the default root). */
const ILLUSTRATION_FRAME_PX = 144;

/**
 * Task illustration — type mark on interactive cards, keyed by storyboard subtype.
 * Square frame matches the 1024 assets so the art lines up with the text below.
 */
const InteractiveElementIllustration = ({
  kind,
  className,
}: InteractiveElementIllustrationProps) => (
  <img
    src={INTERACTIVE_ILLUSTRATION_SRC[kind]}
    alt={INTERACTIVE_ILLUSTRATION_ALT[kind]}
    data-slot="interactive-element-illustration"
    data-kind={kind}
    width={ILLUSTRATION_FRAME_PX}
    height={ILLUSTRATION_FRAME_PX}
    className={cn(
      "pointer-events-none block size-36 max-w-full shrink-0 select-none object-contain",
      className
    )}
  />
);

export default InteractiveElementIllustration;
